import {PayloadAction} from '@reduxjs/toolkit';
//types
import {
  IAdminAllEventsResponse,
  IAdminAllOrganizationsResponse,
  IAdminAllTransactionsResponse,
  IAdminInfo,
  IAdminLoginResponse,
  IAdminOrganizationResponse,
  IAdminPercentage,
  IAdminStatisticResponse,
  ISuperAdminReducer,
} from '@/utils/types/superAdmin.interface';

export const pendingOperation = (state: ISuperAdminReducer) => {
  state.isLoading = true;
};

export const rejectedOperation = (state: ISuperAdminReducer) => {
  state.isLoading = false;
};

export const superAdminLoginOperation = (state: ISuperAdminReducer, {payload}: PayloadAction<IAdminLoginResponse>) => {
  state.isLoading = false;
  if (payload.requiresTwoFactor) return;

  state.superAdminInfo = payload.admin;
};

export const superAdminLogoutOperation = (state: ISuperAdminReducer) => {
  state.superAdminInfo = null;
  state.isLoading = false;
};

export const getSuperAdminInfoOperation = (state: ISuperAdminReducer, {payload}: PayloadAction<IAdminInfo>) => {
  state.superAdminInfo = payload;
  state.isLoading = false;
};

export const getAllOrganizationsOperation = (
  state: ISuperAdminReducer,
  {payload}: PayloadAction<IAdminAllOrganizationsResponse>
) => {
  state.organizationList = payload;
  state.isLoading = false;
};

export const getOrganizationOperation = (
  state: ISuperAdminReducer,
  {payload}: PayloadAction<IAdminOrganizationResponse>
) => {
  state.organization = payload;
  state.isLoading = false;
};

export const getAdminTransactionsOperation = (
  state: ISuperAdminReducer,
  {payload}: PayloadAction<IAdminAllTransactionsResponse>
) => {
  state.transactionList = payload;
  state.isLoading = false;
};

export const getAdminEventsOperation = (
  state: ISuperAdminReducer,
  {payload}: PayloadAction<IAdminAllEventsResponse>
) => {
  state.eventsList = payload;
  state.isLoading = false;
};

export const getAdminStatisticsOperation = (
  state: ISuperAdminReducer,
  {payload}: PayloadAction<IAdminStatisticResponse>
) => {
  state.statistic = payload;
  state.isLoading = false;
};

export const getPlatformFeeOperation = (state: ISuperAdminReducer, {payload}: PayloadAction<IAdminPercentage>) => {
  state.platformFee = payload.platformFeePercent;
  state.isLoading = false;
};

export const superAdminLogin2FactorOperation = (
  state: ISuperAdminReducer,
  {payload}: PayloadAction<IAdminLoginResponse>
) => {
  state.superAdminInfo = payload.admin;
  state.isLoading = false;
};
